// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"00d75749","252":"4ba43c68","270":"6143c9ad","340":"aace4a2b","362":"543fb7ff","413":"c6641739","432":"6b299f82","440":"08ce4680","483":"4b8d4665","803":"de4a5563","879":"310241ef","922":"a20d4003","978":"35384372"}[chunkId] + ".chunk.js";
};